export const GifComponent = ({
    className,
    sourceGif,
    sourceBkg,
    title,
    mp4,
    copy
}) => {
  return (
    <>
        <div className={`gifComponent ${className}`}>
            <div className="gifComponentContent" style={{ backgroundImage: `url(" ${sourceBkg}` , backgroundRepeat  : 'no-repeat', backgroundPosition: 'center', backgroundSize: 'cover', }}>
                <figure>
                    <img src={sourceGif} className="gifVideo" />
                </figure>
            </div>
            <div className="videoContainer">
                <video width="100%" height="240" autoPlay loop muted>
                    <source src={mp4} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>
            <div className="captionTitleCopy">
                <h3>{title}</h3>
                <p>{copy}</p>
            </div>
        </div>
    </>
  );
};
